import { bindable } from "aurelia-templating";
import { autoinject } from "aurelia-dependency-injection";

@autoinject()
export class CodeEditor {

    private _aceEditor: any;

    public editor: HTMLDivElement;

    @bindable
    public label: string;

    @bindable
    public value: string;

    @bindable
    public info: string = "";

    @bindable
    public placeholder: string = "";

    @bindable
    public readonly: boolean;

    @bindable
    public disabled: boolean;

    @bindable
    public tab: number;

    @bindable
    public language: string = "csharp";

    valueChanged() {
        if (this._aceEditor) {
            if (this._aceEditor.getValue() != this.value) {
                this._aceEditor.setValue(this.value, 1);
            }
        }
    }

    attached() {
        this.initialize().then(() => {
            this._aceEditor = window["ace"].edit(this.editor);
            this._aceEditor.session.setMode("ace/mode/" + this.language);
            this._aceEditor.setValue(this.value || '', 1);
            this._aceEditor.on("change", () => {
                this.value = this._aceEditor.getValue();
            })
        });
    }

    detached() {
        if (this._aceEditor) {
            this._aceEditor.destroy();
        }
    }

    public initialize() {
        return new Promise<void>((resolve) => {

            if ($('script[src="https://cdnjs.cloudflare.com/ajax/libs/ace/1.4.5/ace.js"]').length > 0) {
                resolve();
            }

            const script = document.createElement("script")
            script.type = "text/javascript";

            if (script["readyState"]) {  //IE
                script["onreadystatechange"] = () => {
                    if (script["readyState"] == "loaded" ||
                        script["readyState"] == "complete") {
                        script["onreadystatechange"] = null;
                        resolve();
                    }
                };
            } else {  //Others
                script.onload = () => {
                    resolve();
                };
            }

            script.src = "https://cdnjs.cloudflare.com/ajax/libs/ace/1.4.5/ace.js";
            document.getElementsByTagName("head")[0].appendChild(script);
        });
    }
}
